import { Link } from 'react-router';
import type { MeetingSummary } from '../../shared/api/types';
import { formatWhen } from '../events/shared';

/** Lista de reuniones (próximas primero). */
export function MeetingsList({ items, showMinistry = false }: { items: MeetingSummary[]; showMinistry?: boolean }) {
  return (
    <ul className="list">
      {items.map((m) => (
        <li key={m.id} className="list__item">
          <span className="agenda__body">
            <Link to={`/app/reuniones/${m.id}`}>
              <strong>{m.topic}</strong>
            </Link>
            <span className="muted small">
              {formatWhen(m.startsAt, m.endsAt)}
              {m.placeName ? ` · ${m.placeName}` : ''}
            </span>
            <span className="small">
              {showMinistry || m.withMinistries.length ? `${[m.ministry, ...m.withMinistries].map((x) => x.name).join(' + ')} · ` : ''}
              {m.cell ? `Célula ${m.cell.name}` : m.withMinistries.length ? 'Reunión combinada' : 'Todo el ministerio'}
              {m.hasFood ? ' · Con comida' : ''}
            </span>
          </span>
          {m.canceled ? <span className="badge">Cancelada</span> : null}
        </li>
      ))}
    </ul>
  );
}
